import { create } from 'zustand';
import {
  AssessmentStates, InterviewerStates,
  QuestionStates, QuestionsTypes
} from './constant';

const defaults = {
  challenge: {
    title: "Challenge 1",
    description: ""
  },
  sectionTimeData: {
    totalTime: 0,
    warningTime: 0,
    showTimer: false 
  },

  timeLeft: 0,
  attempt: {},

  assessmentState: AssessmentStates.FULL_SCREEN_PERMISSION,
  questionState: QuestionStates.WAITING,
  interviewerState: InterviewerStates.LISTINING,
  questionType: QuestionsTypes.MAIN,
  triggerHint: false,
  hints: [],
  timeOut: false,

  analysis: {
    [QuestionsTypes.MAIN]: {
      questionType: QuestionsTypes.MAIN,
      analysis: {},
      sourceCode: "",
      duration: 0,
      explanation: '',
      submitted: false,
      error: false,
      skip: false
    },
    [QuestionsTypes.FOLLOW_UP_1]: {
      questionType: QuestionsTypes.FOLLOW_UP_1,
      question: '',
      analysis: {},
      sourceCode: "",
      duration: 0,
      explanation: '',
      submitted: false,
      error: false,
      skip: false
    },
    [QuestionsTypes.FOLLOW_UP_2]: {
      questionType: QuestionsTypes.FOLLOW_UP_2,
      question: '',
      analysis: {},
      sourceCode: "",
      duration: 0,
      explanation: '',
      submitted: false,
      error: false,
      skip: false
    }
  }
};

const useCodingStore = create(
  (set, get) => ({
      ...defaults,
      setChallenge: (challenge)=> set({ challenge }),
      setTimeLeft: (timeLeft)=> set({ timeLeft }),
      setAssessmentState: (assessmentState)=> set({ assessmentState }),
      setQuestionState: (questionState)=> set({ questionState }),
      setInterviewerState: (interviewerState)=> set({ interviewerState }),
      setQuestionType: (questionType)=> set({ questionType }),
      setAttempt: (attempt)=> set({ attempt }),
      setAnalysis: (analysis)=> set({ analysis }),
      setTriggerHint: (triggerHint)=> set({ triggerHint }),
      setHints: (hints)=> set({ hints }),
      setTimeOut: (timeOut)=> set({ timeOut }),
      setSectionTimeData: (sectionTimeData)=> set({ sectionTimeData }),

      startTutorial: () => set(({
        assessmentState: AssessmentStates.SHOWING_TUTORIAL,
      })),
      endTutorial: () => set(({
        assessmentState: AssessmentStates.STARTING,
      })),
      startAssessment: () => set(({
        assessmentState: AssessmentStates.RUNNING,
        questionState: QuestionStates.INTERVIEWER_ASKING,
        interviewerState: InterviewerStates.SPEAKING,
      })),
      finishAssessment: () => set(({
        assessmentState: AssessmentStates.FINISHING,
        questionState: QuestionStates.WAITING,
      })),
      startCoding: () => set(({
        questionState: QuestionStates.CODING,
        interviewerState: InterviewerStates.LISTINING,
      })),
      startRecording: () => set(({
        questionState: QuestionStates.RECORDING,
      })),
      endRecording: () => set(({
        questionState: QuestionStates.RECORDED,
      })),

      updateAnalysis: (data)=> set(state=>{
        const currentType = state.questionType;

        return {
          analysis: {
            ...state.analysis,
            [currentType]: {
              ...state.analysis[currentType],
              ...data
            }
          }
        };
      }),



      reset: () => set(defaults),
  }),
);

export default useCodingStore;